<template>
  <div v-if="!grantWithdrawalRight" class="relative flex items-start">
    <div class="flex">
      <input
        id="acceptWithdrawal"
        name="acceptWithdrawal"
        type="checkbox"
        @change="changed"
        class="h-4 w-4 mt-0.5 rounded-full border-gray-300 text-primary-500 focus:ring-primary-500"
      />
    </div>
    <label
      for="acceptWithdrawal"
      class="text-sm text-left pl-2 font-normal text-gray-500 cursor-pointer"
      v-html="$t('no_grant')"
    ></label>
  </div>
  <div v-else class="text-sm text-left pl-2 font-normal text-gray-500">
    <span v-html="$t('grant')"></span>
  </div>
</template>

<i18n>
en:
  no_grant: I agree that by making this purchase, my right of revocation expires, as I will receive immediate access to digital content. I have read and understood the <a class="underline text-primary-500 hover:text-primary-600" href="/portal/revocation" _target="blank">revocation policy</a>.
  grant: I have a 14&#8209;day <a class="underline text-primary-500 hover:text-primary-600" href="/portal/revocation" target="_blank">right of revocation</a> for the purchase of this item.

de:
  no_grant: Ich stimme zu, dass mit dem Kauf mein Widerrufs&shy;recht erlischt, da ich sofort Zugriff auf digitale Inhalte erhalte. Ich habe die <a class="underline text-primary-500 hover:text-primary-600" href="/portal/widerrufsbelehrung" _target="blank">Widerrufsbelehrung</a> gelesen und verstanden.
  grant: Für den Kauf dieses Artikels habe ich ein 14&#8209;tägiges <a class="underline text-primary-500 hover:text-primary-600" href="/portal/widerrufsbelehrung" target="_blank">Widerrufsrecht</a>.
</i18n>

<script>
export default {
  props: ['text', 'grantWithdrawalRight'],
  methods: {
    changed(ev) {
      this.$emit('change', ev.target.checked)
    }
  }
}
</script>
